// feedback messages 
export const SET_FEEDBACK_MESSAGE = 'SET FEEDBACK MESSAGE';
export const SET_FEEDBACK_MESSAGE_VARIANT = 'SET FEEDBACK MESSAGE VARIANT';
export const OPEN_FEEDBACK_MESSAGE = 'OPEN FEEDBACK MESSAGE';
export const CLOSE_FEEDBACK_MESSAGE = 'CLOSE FEEDBACK MESSAGE';

// request messages
export const LOAD_SUBSCRIPTIONREQUESTS_SUCCESS = 'LOAD SUBSCRIPTIONREQUESTS SUCCESS';
export const START_LOAD_SUBSCRIPTIONREQUEST = 'START LOAD SUBSCRIPTIONREQUEST';

export const LOAD_SUBSCRIPTIONREQUESTSSIZE_SUCCESS = 'LOAD SUBSCRIPTIONREQUESTS SUCCESS SIZE';
export const START_LOAD_SUBSCRIPTIONREQUESTSIZE = 'START LOAD SUBSCRIPTIONREQUEST SIZE';

export const LOAD_SUBSCRIPTIONS_SUCCESS = 'LOAD SUBSCRIPTIONS SUCCESS';
export const START_LOAD_SUBSCRIPTION = 'START LOAD SUBSCRIPTION';

export const LOAD_ASSET_SUCCESS = 'LOAD ASSET SUCCES';
export const START_LOAD_ASSET = 'START LOAD ASSET';

// Entity related action types.
export const LOAD_ENTITY = 'LOAD_ENTITY';
export const LOAD_ENTITY_SUCCESS  = 'LOAD_ENTITY_SUCCESS';

export const LOAD_COMMUNITY_OWNERSHIPS = 'LOAD_COMMUNITY_OWNERSHIPS';
export const COMMUNITY_OWNERSHIPS_LOADING = 'COMMUNITY_OWNERSHIPS_LOADING'; 
export const LOAD_COMMUNITY_OWNERSHIPS_SUCCESS = 'LOAD_COMMUNITY_OWNERSHIPS_SUCCESS';
export const LOAD_COMMUNITY_OWNERSHIPS_ERROR = 'LOAD_COMMUNITY_OWNERSHIPS_ERROR';

export const LOAD_COMMUNITY_MEMBERSHIPS = 'LOAD_COMMUNITY_MEMBERSHIPS';
export const COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING = 'COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING'; 
export const LOAD_MORE_COMMUNITY_MEMBERSHIPS = 'LOAD_MORE_COMMUNITY_MEMBERSHIPS';
export const MORE_COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING = 'MORE_COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING'; 
export const LOAD_COMMUNITY_MEMBERSHIPS_SUCCESS = 'LOAD_COMMUNITY_MEMBERSHIPS_SUCCESS';
export const LOAD_MORE_COMMUNITY_MEMBERSHIPS_SUCCESS = 'LOAD_MORE_COMMUNITY_MEMBERSHIPS_SUCCESS';
export const LOAD_COMMUNITY_MEMBERSHIPS_ERROR = 'LOAD_COMMUNITY_MEMBERSHIPS_ERROR';

export const LOAD_COMMUNITY_CONFIGS = 'LOAD_COMMUNITY_CONFIGS';
export const COMMUNITY_CONFIGS_LOADING = 'COMMUNITY_CONFIGS_LOADING'; 
export const LOAD_COMMUNITY_CONFIGS_SUCCESS = 'LOAD_COMMUNITY_CONFIGS_SUCCESS';
export const LOAD_COMMUNITY_CONFIGS_ERROR = 'LOAD_COMMUNITY_CONFIGS_ERROR';

export const LOAD_COMMUNITY_STATISTICS = 'LOAD_COMMUNITY_STATISTICS';
export const COMMUNITY_STATISTICS_LOADING = 'COMMUNITY_STATISTICS_LOADING'; 
export const LOAD_COMMUNITY_STATISTICS_SUCCESS = 'LOAD_COMMUNITY_STATISTICS_SUCCESS';
export const LOAD_COMMUNITY_STATISTICS_ERROR = 'LOAD_COMMUNITY_STATISTICS_ERROR';




// WEBPACK FOOTER //
// ./src/modules/core/actions/actionTypes.tsx